import './print.css';
import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';

import Content from './Content';
import Cancellation from '../Cancellation';
import ChangeFastSend from '../ChangeFastSend';
import ChangeShipping from '../ChangeShipping';
import ChangePaymentType from '../ChangePaymentType';
import ChangePaymentStatus from '../ChangePaymentStatus';
import RefundOrderToWallet from '../RefundOrderToWallet';
import RefundShippingToWallet from '../RefundShippingToWallet';

import { useReactToPrint } from 'react-to-print';
import { NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle, UserAvatar } from 'components';

export default function ControlCenter({ model, refetch }) {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const {
    id,
    call_me,
    fast_send,
    total_cost,
    shipping_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
    shop,
    status,
    customer,
  } = model;

  const printRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const promiseResolveRef = useRef(null);

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
      });
    },
    onAfterPrint: () => {
      promiseResolveRef.current = null;
      setIsPrinting(false);
    },
  });

  return (
    <>
      <IconButton size="small" sx={{ bgcolor: 'info.lighter', color: 'info.dark' }} color="info" onClick={onOpen}>
        <MoreVertRoundedIcon fontSize="small" />
      </IconButton>
      <NewDialog label="create" open={open} onClose={onClose} maxWidth="md">
        <NewDialogTitle
          title={
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Typography
                  textAlign="center"
                  variant="subtitle1"
                  color="text.secondary"
                  fontSize={16}
                  letterSpacing={3}
                >
                  {tracking_code.split('.')[1]}
                </Typography>
                <Typography textAlign="center" variant="subtitle1" color="text.secondary" fontSize={14}>
                  {shop.title}
                </Typography>
              </Stack>
            </Stack>
          }
          onClose={onClose}
          actions={<UserAvatar customer={customer} />}
        />
        <NewDialogContent isPopup>
          <Box sx={{ direction: 'ltr' }} ref={printRef} px={1}>
            <Box className="print-header">
              <Stack rowGap={2} borderRadius={2}>
                <p color="#000" variant="h3">
                  فاکتور واحد جمع آوری
                </p>
                <Stack direction="row" justifyContent="space-between">
                  <p color="#000" variant="h5">
                    شماره سفارش
                  </p>
                  <p color="#000" variant="h2">
                    {id}
                  </p>
                </Stack>
              </Stack>
            </Box>
            <Content model={model} />
          </Box>
        </NewDialogContent>
        <NewDialogActions>
          <Box
            sx={{
              py: 0,
              columnGap: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'row-reverse',
              borderRadius: 2,
              scrollPadding: 24,
              overflowY: 'hidden',
              overflowX: 'scroll !important',
              scrollSnapType: 'x mandatory',
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            <IconButton
              sx={{ bgcolor: 'info.lighter', color: 'info.dark', alignSelf: 'flex-end' }}
              size="small"
              color="info"
              variant="contained"
              onClick={handlePrint}
            >
              {isPrinting ? <CircularProgress size={25} /> : <PrintRoundedIcon fontSize="small" />}
            </IconButton>
            <RefundShippingToWallet ids={id} title="هزینه حمل" refetch={refetch} />
            <RefundOrderToWallet ids={id} title="هزینه سفارش" refetch={refetch} />
            <ChangePaymentStatus title="وضعیت پرداخت" model={model} refetch={refetch} />
            <ChangePaymentType title="روش پرداخت" model={model} refetch={refetch} />
            <ChangeFastSend model={model} title="ارسال سریع" refetch={refetch} />
            <ChangeShipping title="روش حمل" model={model} refetch={refetch} />
            <Cancellation title="لغو سفارش" model={model} refetch={refetch} />
          </Box>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
